const textsObj = [
  {
    id: 1,
    question: '1. Почему в Пчхикаго паника?',
    answers: [
      {
        result: 1,
        value: 0,
        title: 'В городе Острая Респираторная Плюшевая Инфекция'
      },
      {
        value: 1,
        title: 'Закрылись все аптеки'
      },
      {
        value: 2,
        title: 'В городе подняли налог на отопление, и теперь люди дрожат от холода'
      }
    ],
    results: [{
      active: true,
      bg: 'img/q/result_bg_lg.png',
      label: 'img/q/yes.png',
      text: 'Верно! <br>Город охватила Острая Респираторная Плюшевая Инфекция, и сотни людей превратились в боляк.'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Аптеки еще работают, а вот нужного противовирусного средства там уже нет.'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Нет, отопление в городе работает в штатном режиме ))'
    }]
  },
  {
    id: 2,
    question: '2. Какая специализация у Инспектора 10?',
    answers: [
      {
        result: 1,
        value: 0,
        title: 'Инспектор 10 лучше всего разбирается в делах несовершеннолетних'
      },
      {
        value: 1,
        title: 'Просто красавица'
      },
      {
        value: 2,
        title: 'Знает, чем отличается ОРЗ от ОРПИ'
      }
    ],
    results: [{
      active: true,
      bg: 'img/q/result_bg_xlg.png',
      label: 'img/q/yes.png',
      text: 'Верно. Она знает, что для профилактики ОРПИ надо использовать по одной таблетке Кагоцела в день дважды в неделю.*<small>*Профилактика гриппа и ОРВИ у детей в возрасте от трех лет проводится 7-дневными циклами: два дня — по одной таблетке 1 раз в день, пять дней перерыв, затем цикл повторить. Длительность профилактического курса — от одной недели до нескольких месяцев.</small>'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Хорошая попытка, но поискам злодея это не сильно помогает.'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Это проходят на базовом уровне подготовки.'
    }]
  },
  {
    id: 3,
    question: '3. Почему Инспектор 20 — лучший специалист в отделе?',
    answers: [
      {
        value: 0,
        title: 'Работает из дома'
      },
      {
        result: 1,
        value: 1,
        title: 'Принимает противовирусные препараты'
      },
      {
        value: 2,
        title: 'За время работы выработал иммунитет к болезням'
      }
    ],
    results: [{
      bg: 'img/q/result_bg_lg.png',
      label: 'img/q/no.png',
      text: 'Хорошее решение для того, чтобы ограничить контакты с больными людьми и снизить риск заражения. Но разве тогда был бы Инспектор 20 лучшим в отделе?'
    }, {
      active: true,
      bg: 'img/q/result_bg_lg.png',
      label: 'img/q/yes.png',
      text: 'Совершенно верно. Благодаря регулярной профилактике из двух таблеток Кагоцела дважды в неделю, Инспектор 20 остается в строю и полон сил даже в самые суровые времена.'
    }, {
      bg: 'img/q/result_bg_xlg.png',
      label: 'img/q/no.png',
      text: 'Ко всем вирусам простуды невозможно выработать иммунитет. Вирусы постоянно мутируют — это естественное состояние. Они взаимодействуют с конкретной клеткой, получают от нее информацию, которую и наследуют. Таким образом появляются все новые и новые опасности для организма человека.'
    }]
  },
  {
    id: 4,
    question: '4. Как заразилась Инспектор 10?',
    answers: [
      {
        result: 1,
        value: 0,
        title: 'На нее чихнул боляка'
      },
      {
        value: 1,
        title: 'Ехала на дело с открытым окном в автомобиле'
      },
      {
        value: 2,
        title: 'Контактировала с уликами в квартире, где нашли ребенка-боляку'
      }
    ],
    results: [{
      active: true,
      bg: 'img/q/result_bg_lg.png',
      label: 'img/q/yes.png',
      text: 'Верно! При чихании и кашле возбудители, которые собираются на слизистой, поступают в воздушную среду и становятся почти биологическим оружием.'
    }, {
      bg: 'img/q/result_bg_lg.png',
      label: 'img/q/no.png',
      text: 'Действительно, холодный поток воздуха (сквозняк), может спровоцировать воспаление шейных мышц или обострение хронических инфекций, но не простуду.'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Неверно! При контакте с уликами заражения не происходит.'
    }]
  },
  {
    id: 5,
    question: '5. Как инспекторы лечили заразившихся боляк?',
    answers: [
      {
        result: 1,
        value: 0,
        title: 'Применяли Кагоцел'
      },
      {
        value: 1,
        title: 'Раздавали аскорбиновую кислоту'
      },
      {
        value: 2,
        title: 'Делали прививки'
      }
    ],
    results: [{
      active: true,
      bg: 'img/q/result_bg_xlg.png',
      descrBox: true,
      label: 'img/q/yes.png',
      text: 'Верно! Инспекторы применяли Кагоцел и по возможности давали пострадавшим упаковку, чтобы боляки могли пройти полный курс лечения. Для взрослых — пачка с 20 таблетками. Для детей от 3 лет — с 10 таблетками*.'
    }, {
      bg: 'img/q/result_bg.png',
      label: 'img/q/no.png',
      text: 'Хорошее средство для смягчения симптомов за счет витамина С, но простуду это не предотвратит.'
    }, {
      bg: 'img/q/result_bg_xlg.png',
      label: 'img/q/no.png',
      text: 'Существует больше двухсот подтипов различных вирусов, которые вызывают ОРПИ. На данный момент далеко не все они идентифицированы иммунологами, а значит, и вылечить всех боляк с помощью прививок не получится.'
    }]
  }
];
const resultObj = [{
  result: 'Не отчаивайся!<br> Еще раз внимательно ознакомься с <a href="#" target="_blank">видеоматериалами</a>. <br>И помни, <a href="#" target="_blank">Кагоцел</a> работает даже при запоздалом лечении!'
}, {
  result: 'Хороший результат! <br>Самое сложное — это разобраться в дозировках, поэтому предлагаем еще раз ознакомиться с инструкцией по применению:<br> <a href="https://www.kagocel.ru/about_drug/instrukciya/" target="_blank">посмотреть инструкцию</a>'
}, {
  result: 'Почти отлично :)<br> Поздравляем! Уверены, что с вашей помощью мы сможем победить любые вирусы. Ознакомьтесь еще раз с лучшим оружием против гриппа и ОРВИ: <br><a href="https://www.kagocel.ru/about_drug/" target="_blank">о препарате</a> '
}, {
  result: 'Поздравляем! Редко встречаются люди, которые так быстро все схватывают на лету! Помни, <a href="https://www.kagocel.ru" target="_blank">Кагоцел</a> работает даже при запоздалом лечении.'
}];

let step = 0;
let finaleState = false;
let counterAnswer = 0;

$('.js-test-start').on('click', function() {
  $(this).closest('.test').addClass('is-active');
  renderStep();
});

$(document).on('click', '.js-test-refresh', () => {
  resetTest();
});

$(document).on('click', '.js-test-next', () => {
  step += 1;
  renderStep();
  resetStep();
});

$(document).on('change', '.answers input', function() {
  $('.js-test-answer').removeClass('is-disabled');

  const resultIndex = $(this).val();
  const objCurrent = textsObj[step].results[resultIndex];
  const valueInput = $(this).data('value');

  if (valueInput !== 'undefined') {
    counterAnswer += valueInput;
  }

  $('.test').addClass('is-result-active');
  $('.questionResult').replaceWith(createResult(objCurrent.text, objCurrent.label, objCurrent.bg, objCurrent.descrBox));
});

$(document).on('click', '.js-test-answer', () => {

});

function createStep(id, question, answers) {
  let templateStep = `
    <div class="test__step" data-step="${id}">
      <div class="question">${question}</div>
      <div class="answers"></div>
    </div>  
  `;

  templateStep = $(templateStep);

  for (let i = 0; i < answers.length; i += 1) {
    const templateRadio = `
         <div class="radioButton">
          <input type="radio" name="answer_${id}" value="${answers[i].value}" data-value="${answers[i].result}">
          <span>${answers[i].title}</span>
        </div>
    `;

    templateStep.find('.answers').append(templateRadio);
  }

  return templateStep;
}

function renderStep() {
  const $el = $('[data-step]');

  if (step === textsObj.length) {
    $el.remove();
    testFinal();
    return;
  }

  if ($el.length) {
    $el.replaceWith(createStep(textsObj[step].id, textsObj[step].question, textsObj[step].answers));
  } else {
    $('.testBody').append(createStep(textsObj[step].id, textsObj[step].question, textsObj[step].answers));
  }
  $('.test__pagination .current').html(textsObj[step].id);
}

function createResult(title, label, bg, descrBox) {
  return `
    <div class="questionResult is-active" style="background-image: url(${bg});">
        <div class="questionResult__label" style="background-image: url(${label});"></div>
        <div class="questionResult__text">
            ${title}
        </div>
        
        ${descrBox ? `
        
        <div class="descrBox">
            <div class="descrBox__head">
                *посмотреть сноску
            </div>
            <div class="descrBox__body">
                <div class="descrBox__inner">
                <a href="javascript:void(0);" class="descrBox__close"><svg class="icon icon-close">
                <use xlink:href="img/sprite.svg#icon-close"></use>
              </svg></a>
                    <div class="descrBox__text">
                        <p>*Для лечения гриппа и ОРВИ взрослым назначают Кагоцел в первые два дня — по 2 таблетки 3 раза в день, в последующие два дня — по одной таблетке 3 раза в день. Всего на курс — 18 таблеток, длительность курса — 4 дня.</p>
                        <p>Для лечения гриппа и ОРВИ детям в возрасте от 3 до 6 лет назначают в первые два дня — по 1 таблетке 2 раза в день, в последующие два дня — по одной таблетке 1 раз в день. Всего на курс — 6 таблеток, длительность курса — 4 дня. Для лечения гриппа и ОРВИ детям в возрасте от 6 лет назначают в первые два дня — по 1 таблетке 3 раза в день, в последующие два дня — по одной таблетке 2 раза в день. Всего на курс — 10 таблеток, длительность курса — 4 дня.</p>
                    </div>
                </div>
            </div>
        </div>
        
        ` : ''}
        
        <div class="questionResult__link">
            <a href="javascript:void(0);" class="btn btn--start js-test-next">
                <span>Далее</span>
            </a>
        </div>
    </div>
  `;
}

function resetStep() {
  $('.questionResult').removeClass('is-active');
  $('.test').removeClass('is-result-active');
}

function testFinal() {
  finaleState = true;
  $('.test').addClass('is-completed');

  let index = 0;
  let gaLabel;

  if (counterAnswer < 3) {
    $('.test__step--end .test__text').html(resultObj[index].result);
    gaLabel = 'Bad';
  }

  if (counterAnswer === 3) {
    index = 1;
    $('.test__step--end .test__text').html(resultObj[index].result);
    gaLabel = 'Bad';
  }

  if (counterAnswer === 4) {
    index = 2;
    $('.test__step--end .test__text').html(resultObj[index].result);
    gaLabel = 'Normal';
  }

  if (counterAnswer === 5) {
    index = 3;
    $('.test__step--end .test__text').html(resultObj[index].result);
    gaLabel = 'Good';
  }

  ga('send', 'event', 'test_result', 'final_step', gaLabel);
  
  console.log(gaLabel)

  $('.socialsBox .socials').replaceWith(` 
  <ul class="socials">
      <li>
        <a href="https://vk.com/share.php?url=https://www.kagocel.ru/city" target="_blank">
          <i class="icon icon-vk" style="background-image: url('img/socials/vk.png');"></i>
          <i class="icon icon-vk icon--hover" style="background-image: url('img/socials/vk-hover.png');"></i>
        </a>
      </li>
      <li>
        <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//www.kagocel.ru/city" target="_blank">
          <i class="icon icon-fb" style="background-image: url('img/socials/fb.png');"></i>
          <i class="icon icon-fb icon--hover" style="background-image: url('img/socials/fb-hover.png');"></i>
        </a>
      </li>
      <li>
        <a href="https://connect.ok.ru/offer?url=https://www.kagocel.ru/city" target="_blank">
          <i class="icon icon-od" style="background-image: url('img/socials/od.png');"></i>
          <i class="icon icon-od icon--hover" style="background-image: url('img/socials/od-hover.png');"></i>
        </a>
      </li>
      <li>
        <a href="https://twitter.com/home?status=https%3A//www.kagocel.ru/city" target="_blank">
          <i class="icon icon-tw" style="background-image: url('img/socials/tw.png');"></i>
          <i class="icon icon-tw icon--hover" style="background-image: url('img/socials/tw-hover.png');"></i>
        </a>
      </li>
    </ul>
  `);
}

function resetTest() {
  resetStep();
  $('.test').removeClass('is-completed');
  step = 0;
  finaleState = false;
  counterAnswer = 0;
  $('.test__pagination .current').html(1);
  renderStep();
}

$(document).on('click', '.descrBox__head, .descrBox__close', () => {
  $('.descrBox').toggleClass('is-active');
});
